import moment from 'moment';

export const CEREMONY_DATE = moment.parseZone('2019-08-03T18:15:00-05:00');
export const RECEPTION_DATE = moment.parseZone('2019-08-03T19:00:00-05:00');
export const PRECEPTION_DATE = moment.parseZone('2019-06-30T16:00:00-08:00');



// WEBPACK FOOTER //
// ./src/constants.js